import React from 'react';

// Styles
import styles from './style.module.scss';

interface CustomButtonProps {
  children?: React.ReactNode;
  variant?: "primary" | "secondary" | "text";
  icon?: React.ReactNode;
  classes?: {
    root?: string;
    icon?: string;
    disabled?: string;
  };
  type?: HTMLButtonElement['type'];
  disabled?: boolean;
  onClick?: React.ButtonHTMLAttributes<HTMLButtonElement>['onClick'];
  onMouseEnter?: React.ButtonHTMLAttributes<HTMLButtonElement>['onMouseEnter'];
  onTouchStart?: React.ButtonHTMLAttributes<HTMLButtonElement>['onTouchStart'];
}

const CustomButton: React.FC<CustomButtonProps> = ({
  children, variant = "contained", icon, classes, disabled, type, ...props
}) => {
  let buttonClasses = styles.button;
  switch (variant) {
    case 'primary':
      buttonClasses += ` ${styles.contained}`;
      break;
    case 'secondary':
      buttonClasses += ` ${styles.outlined}`;
      break;
    case 'text':
      buttonClasses += ` ${styles.text}`;
      break;
  }

  return (
    <button className={`${buttonClasses} ${classes?.root}`} type={type || 'button'} disabled={disabled} {...props}>
      {icon && <span className={styles.icon}>{icon}</span>}

      {children}
    </button>
  );
};

export default CustomButton;
